import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapsService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;
  markSaved = new Subject<void>();

  mapCoordinates(data: any) {
    return this.#http.postData(
      `${this.baseUrl}/CoordinateMapping`,
      { showLoader: true, showMessage: true, message: 'Map Coordinates' },
      data
    );
  }

  deleteMapCoordinates(id: string) {
    return this.#http.deleteData(`${this.baseUrl}/CoordinateMapping/projects/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Map Coordinates'
    });
  }

  getMapCoordinates(projectId: string) {
    return this.#http.getData(`${this.baseUrl}/CoordinateMapping/projects/${projectId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  uploadMapImage(projectId: string, mapImageDocumentId: string, data: any) {
    return this.#http.putData(
      `${this.baseUrl}/CoordinateMapping/projects/${projectId}/map-image?mapImageDocumentId=${mapImageDocumentId}`,
      data,
      { showLoader: true, showMessage: true }
    );
  }

  getMappingByLotId(lotId: string) {
    return this.#http.getData(`${this.baseUrl}/CoordinateMapping/lots/${lotId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  deleteMappingById(id: string) {
    return this.#http.deleteData(`${this.baseUrl}/CoordinateMapping/${id}`, { showLoader: true, showMessage: true });
  }

  markSaved$ = this.markSaved.asObservable();

  scheduledReservedLots(projectId: string) {
    return this.#http.getData(`${this.baseUrl}/deal-schedules/project?projectId=${projectId}`, {
      showLoader: false,
      showMessage: false
    });
  }
}
